import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import { buildAutoPinSettingDefaults, buildAutoPinSettingsDisableAll } from "../../models/KeySelectionOptions.model";
import TextButton from "../theme_reuse/TextButton";
import AutoIgnore2Toggle from "./AutoIgnore2Toggle";
import AutoIgnore3Toggle from "./AutoIgnore3Toggle";
import AutoIgnore5Toggle from "./AutoIgnore5Toggle";
import AutoIgnore6Toggle from "./AutoIgnore6Toggle";
import AutoIgnore7Toggle from "./AutoIgnore7Toggle";
import NoteOverrideDemo from "./NoteOverrideDemo";

interface Props {}
interface State {}

export default class NoteOverrideAutoSettings extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  handleResetAllAuto = () => {
    this.context.dispatch({
      type: "EditKeySelectionOptions",
      payload: { ...this.context.keySelectionOptions, autoPin: buildAutoPinSettingDefaults() },
    });
  };
  handleDisableAllAuto = () => {
    this.context.dispatch({
      type: "EditKeySelectionOptions",
      payload: { ...this.context.keySelectionOptions, autoPin: buildAutoPinSettingsDisableAll() },
    });
  };

  render(): ReactNode {
    return (
      <>
        <h3>Automatic note pinning</h3>
        <p>
          <TextButton text="Disable All" onClick={this.handleDisableAllAuto} />
          <TextButton text="Reset To Default" onClick={this.handleResetAllAuto} />
        </p>
        <p>Choose whether dubious notes are automatically toggled into "ignore" mode, for a cleaner read.</p>
        <AutoIgnore2Toggle />
        <AutoIgnore3Toggle />
        <AutoIgnore5Toggle />
        <AutoIgnore6Toggle />
        <AutoIgnore7Toggle />
        <p>If the detected scale changes, the automation will re-run unless you manually override.</p>
        <details>
          <summary>How to manually override?</summary>
          <NoteOverrideDemo />

          {/* <ul>
            <li>2nd: No scale includes a half step interval above the root.</li>
            <li>3rd: No scale includes both a minor and major 3rd from the root of the scale.</li>
            <li>5th: Flat 5th is unlikely outside of a Blues/pentatonic context.</li>
            <li>6th/7th: Only melodic minor scales include both a minor and major 6th + 7th.</li>
          </ul>
          <p>
            Note: Different rules apply if scales are major vs. minor. For example, the same note is silenced by a minor root to flat 5 rule
            as by a major root to minor third rule.
          </p> */}
        </details>
      </>
    );
  }
}

NoteOverrideAutoSettings.contextType = AppContextType;
